export const ServiceType = [
  {
    key: "show_all",
    value: "نمایش همه",
  },
  {
    key: "consulting_and_reviewing_documents",
    value: "مشاوره حقوقی",
  },
  {
    key: "contract_writing",
    value: "نگارش قرارداد",
  },
  {
    key: "petition",
    value: "تنظیم دادخواست و لوایح حقوقی",
  },
  {
    key: "complaints",
    value: "تنظیم شکوایه و لوایح کیفری ",
  },
  {
    key: "international",
    value: "حقوق بازرگانی بین الملل  ",
  },
  {
    key: "advocacy_acceptation",
    value: "وکالت در دادگاه  ",
  },
];

export const ServiceState = [
  {
    key: "show_all",
    value: "نمایش همه",
  },
  {
    key: "LOOKING_FOR_LAWYER",
    value: "در انتظار وکیل ",
  },
  {
    key: "OPEN",
    value: "باز",
  },
  {
    key: "STARTED",
    value: "در حال انجام ",
  },
  {
    key: "WAITING_FOR_CATEGORY",
    value: "بدون دسته بندی ",
  },
  {
    key: "READY_FOR_PAYMENT",
    value: "در انتظار پرداخت ",
  },
  {
    key: "RECHARGE_NEEDED",
    value: "نیاز به تمدید ",
  },
  {
    key: "CLOSED",
    value: "تمام شده ",
  },
  {
    key: "CLOSED_BY_ADMIN ",
    value: "پایان یافته توسط ادمین",
  },
];
